import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Container from '../../../../components/Container'
import api from '../../../../services/api'
import { useToast } from '../../../../hooks/toast'
import { useLoading } from '../../../../hooks/loading'
import { FormAdvertisements } from '../components/Form'
import { apiList } from '../domain/api'
import { nameActions } from '../domain/info'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'

const AdvertisementsUpdate = (): JSX.Element => {
  const { id } = useParams<{ id: string }>()
  const { addToast } = useToast()
  const { activeLoading, disableLoading } = useLoading()
  const [advertisement, setAdvertisement] = useState<
    AdvertisementsApiResponse | undefined
  >()

  useEffect(() => {
    async function loadAdvertisement(): Promise<void> {
      activeLoading()
      try {
        const response = await api.get<AdvertisementsApiResponse>(apiList(id))
        setAdvertisement(response.data)
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao carregar o anúncio',
          description:
            'Houve um erro ao carregar o anúncio, tente novamente mais tarde.'
        })
      } finally {
        disableLoading()
      }
    }

    loadAdvertisement()
  }, [activeLoading, addToast, disableLoading, id])

  return (
    <Container
      pageTitle={nameActions.update.name}
      breadcrumb={breadcrumbUpdate}
      tools={toolsUpdate(id)}
    >
      {advertisement && (
        <FormAdvertisements
          typeForm="update"
          initialValues={{ idUpdate: Number(id), ...advertisement }}
        />
      )}
    </Container>
  )
}

export default AdvertisementsUpdate
